import { placeholders, displayGroups } from '@ui';

import { TouchPointHelper } from '../../../helpers/touchPointHelper';

export const subscriptionConclusion = {
	prismName: 'subscriptionConclusion',
	template: {
		templateName: 'subscriptionConclusionTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.lateralMenu, {
								placeholderBuildReference: 10,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.conclusion, {
										placeholderBuildReference: 300,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 500,
							}),
						]
					),
				]),
			]),
		],
	},
};
